import { Location } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import {
  BackIcon,
  ExportIcon,
  ImportIcon,
  PlusIconSvg,
} from '@g99-product-web-ui/shared-util-lib';

import { IColumnPreference } from '../../interfaces/shared-table-column-preference.interface';

@Component({
  selector: 'lib-shared-table-header',
  templateUrl: './shared-table-header.component.html',
  styleUrl: './shared-table-header.component.scss',
  standalone: false,
})
export class SharedTableHeaderComponent {
  @Input() public title!: string;
  @Input() public buttonLabel!: string;
  @Input() public isHeaderButtonHidden = false;
  @Input() public secondaryButtonLabel!: string;
  @Input() public secondaryBtnIcon!: string;
  @Input() public route?: string; // Optional route to navigate
  @Input() public svgIcon = PlusIconSvg;
  @Input() public isBackButtonVisible = false;
  @Input() public isButtonDisable = false;
  @Input() public notificationBadgeCount = 0;
  @Input() public isImportButtonVisible = false;
  @Input() public isExportButtonVisible = false;
  @Input() public availableColumns: IColumnPreference[] = [];
  @Input() public showBackArrow = false;
  @Input() public isAddTagButtonVisible = false;

  @Output() public columnPreferenceChange = new EventEmitter<
    IColumnPreference[]
  >();
  @Output() public buttonClick = new EventEmitter<void>(); // Emits when button is clicked, if no route is provided
  @Output() public secondaryButtonClick = new EventEmitter<void>(); // Emits when button is clicked, if no route is provided
  @Output() public importButtonClick = new EventEmitter<string>(); // Emits when button is clicked, if no route is provided
  @Output() public exportButtonClick = new EventEmitter<void>();
  @Output() public addTagButtonClick = new EventEmitter<void>();
  public importIcon = ImportIcon;
  public exportIcon = ExportIcon;

  protected backArrow = BackIcon;
  constructor(
    private readonly _router: Router,
    private readonly _location: Location
  ) {}

  public onButtonClick(): void {
    if (this.route) {
      this._router.navigate([this.route]);
    } else {
      this.buttonClick.emit();
    }
  }

  public onBackButtonClick(): void {
    this._location.back();
  }

  public onImportClick(): void {
    this.importButtonClick.emit('Import button clicked');
  }

  public onExportClick(): void {
    this.exportButtonClick.emit();
  }

  protected onColumnPreferenceChanged(updated: IColumnPreference[]): void {
    this.columnPreferenceChange.emit(updated);
  }
}
